import { render, staticRenderFns } from "./repWin.vue?vue&type=template&id=54f52d12&scoped=true&"
import script from "./repWin.vue?vue&type=script&lang=js&"
export * from "./repWin.vue?vue&type=script&lang=js&"
import style0 from "./repWin.vue?vue&type=style&index=0&id=54f52d12&scoped=true&lang=less&"
import style1 from "./repWin.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f52d12",
  null
  
)

export default component.exports